// Konfigurasi dari environment (Vite meng-inject VITE_* saat build).
export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
} as const;

/** true bila kredensial Supabase sudah diisi (mode nyata). */
export const isConfigured = (): boolean =>
  Boolean(config.supabaseUrl && config.supabaseAnonKey);
